import {useEffect} from "react";
import {getUrl} from "./lib";
import {setStep, setTrack} from "./tracking";
import {useNavigate} from "react-router-dom";

export const useStep = ({step, toAdd, track = true}) => {
  const navigate = useNavigate()

  useEffect(() => {
    if (!window._uid && !window.localStorage.getItem('uid')) {
      navigate(getUrl('/'))
      return
    }

    setStep(step, toAdd)

    if (track)
      setTrack(step.page)
  }, [])
}